
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import 'moment/locale/es'

import config from './config'

import NotificationsActions from './Redux/Actions/NotificationsActions'
import { getApplicationSettingsAction } from './Redux/Actions/ApplicationActions'

import { useAuth } from './Hooks/UseAuth'
import useTranslation from './Hooks/UseTranslation'

import TermsAndPoliciesRequester from './Components/TermsAndPoliciesRequester/TermsAndPoliciesRequester'

import SplashPage from './Pages/SplashPage/SplashPage'

import AppRouter from './AppRouter'

import TopLoader from './Components/TopLoader/TopLoader'
import Toast from './Components/Toast/Toast'
import AsyncConfirm from './Components/AsyncConfirm'

import './App-little-purple.scss'
import './App.scss'
import './icons.scss'

const App = () => {

    const isLeanPreview = process.env.NODE_ENV === 'development' && window.location.pathname === '/preview/lean-indicators'

    const { t, language } = useTranslation()

    moment.locale(language)

    moment.updateLocale(language, {
        weekdays: t('SYSTEM:weekDaysFull').split('_'),
        weekdaysShort: t('SYSTEM:weekDaysShort').split('_'),
        week: {
            dow: 1
        }
    })

    const { isAuthenticated, authToken } = useAuth()

    const dispatch = useDispatch()

    const showLoader = useSelector((state: any) => state.InterfaceReducer.showLoader)
    const [ settingsLoaded, setSettingsLoaded ] = useState(false)

    useEffect(() => {

        const loadSettings = async () => {

            setSettingsLoaded(false)

            await dispatch(getApplicationSettingsAction())

            setTimeout(() => {

                setSettingsLoaded(true)
            }, 1000)
        }

        if (isLeanPreview) {
            setSettingsLoaded(true)
        } else if(!settingsLoaded) loadSettings()
    }, [ isAuthenticated ])

    useEffect(() => {
        let interval: ReturnType<typeof setInterval> | undefined
        const autoLoadNotifications = config.autoLoadNotifications

        if (!authToken) {
            return
        }

        const loadNotifications = () => dispatch(NotificationsActions.loadResult() as any)

        loadNotifications()

        if (autoLoadNotifications) {
            interval = setInterval(loadNotifications, 10000)
        }

        return () => {
            if (interval) clearInterval(interval)
        }
    }, [authToken, dispatch])

    return (
        <div className="App">
            {(!settingsLoaded || (!isLeanPreview && isAuthenticated === undefined)) && <SplashPage />}
            {(settingsLoaded && (isLeanPreview || isAuthenticated !== undefined)) && (
                <>
                    <AppRouter />

                    {!isLeanPreview && <TermsAndPoliciesRequester />}
                </>
            )}

            <TopLoader show={showLoader} />

            <Toast />

            <AsyncConfirm />
        </div>
    )
}

export default App
